import { render, staticRenderFns } from "./ProductDetailCardContent.vue?vue&type=template&id=7d018f97&"
import script from "./ProductDetailCardContent.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports